export default {"src":"/_next/static/media/ComplianceLiteDark.51509789.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};